// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TruncatableText-base__q4TDE{display:block;max-width:var(--size-full);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.TruncatableText-clamp__Gt1Km{display:-webkit-box;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:var(--max-lines)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TruncatableText-base__q4TDE",
	"clamp": "TruncatableText-clamp__Gt1Km"
};
export default ___CSS_LOADER_EXPORT___;
